import { compose } from 'redux';
import { connect } from 'react-redux';
import App from '../../pages/App/App';
import * as Actions from '../../actions/CommonOptions';

const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
});
const mapDispatchToProps = (dispatch) => ({
    getListOptionsRequested: (locale) => {
        dispatch(Actions.GetListOptionsRequested(locale));
    },
});

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(App);
